import React from "react";
import T from "../../../services/lang/LanguageService";

const DevSandbox = () => {
  return (
      <div>
          <li>{T("greeting", {name: "Vardenis Pavardenis"})}</li>
          <li>{T("mango.ango", {name: "Vardenis Pavardenis"})}</li>
          <li>{T("from")}</li>
          <li>{T("to" )}</li>
          <li>{T("side-menu.home")}</li>
      </div>
  );
};

export default DevSandbox;


